import { render, staticRenderFns } from "./PositionComponent.vue?vue&type=template&id=561486c5&scoped=true"
import script from "./PositionComponent.vue?vue&type=script&lang=js"
export * from "./PositionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561486c5",
  null
  
)

export default component.exports